/*
 * Turuncu Etiket ürün kartı sayacı.
 * Markup: snippets/product-card.liquid → [data-hp-orange-card-countdown][data-expires="YYYY-MM-DDTHH:MM:SS"].
 * Tek bir interval sayfadaki tüm kartları günceller (sonradan yüklenen kartlar dahil: her tikte yeniden sorgulanır).
 * Süre dolunca sayaç gizlenir; etiket şeridi yalnızca "Turuncu Etiket" yazısıyla kalır.
 *
 * Yerleşim (şerit genişliği değişince bir kez ölçülür, her saniye değil):
 *  1. ikonlar + saniyeli sayaç sığıyorsa öyle kalır,
 *  2. sığmıyorsa önce ikonlar gizlenir (--no-icons) — saniye ikonlardan önceliklidir,
 *  3. hâlâ sığmıyorsa (çok dar kart) ve gün varsa saniye atılır (--compact).
 * Rakamlar sabit genişlikli hücrelere yazılır; saniye değişirken şeritteki yazı sağa sola oynamaz.
 * Şerit ürün görselinin üstüne bindiği kadar görsel küçültülür (--hp-orange-band-overlap), kart boyu değişmez.
 */
(() => {
  if (window.hpOrangeCardCountdown) return;
  window.hpOrangeCardCountdown = true;

  const SELECTOR = '[data-hp-orange-card-countdown]';
  const BADGE = 'product-card__orange-label-badge';
  const COUNTDOWN = 'product-card__orange-label-countdown';
  const pad = (n) => String(n).padStart(2, '0');
  const layouts = new WeakMap();

  // Karakter başına bir span; yalnızca değişen rakamın metni güncellenir
  const render = (valueEl, text) => {
    if (valueEl.childElementCount !== text.length) {
      valueEl.textContent = '';
      for (const char of text) {
        const span = document.createElement('span');
        span.className = /\d/.test(char) ? `${COUNTDOWN}-char ${COUNTDOWN}-char--digit` : `${COUNTDOWN}-char`;
        span.textContent = char;
        valueEl.appendChild(span);
      }
      return;
    }

    for (let i = 0; i < text.length; i++) {
      const span = valueEl.children[i];
      if (span.textContent !== text[i]) span.textContent = text[i];
    }
  };

  const fits = (badge) => {
    const label = badge.querySelector(`.${BADGE}-text`);
    return !label || label.scrollWidth <= label.clientWidth;
  };

  const measure = (el, badge, card, valueEl, fullText) => {
    badge.classList.remove(`${BADGE}--no-icons`);
    el.classList.remove(`${COUNTDOWN}--compact`);
    render(valueEl, fullText);
    el.hidden = false;

    let compact = false;
    if (!fits(badge)) {
      badge.classList.add(`${BADGE}--no-icons`);
      compact = !fits(badge);
    }

    // Şeridin görsel alanına taşan kısmı (yatay mobil kartta şerit içeriğin üstündedir → 0)
    // Slider'da aktif olmayan kartlar transform ile küçültülür: rect ölçüsü o orana bölünerek gerçek px'e çevrilir
    const overlay = card?.querySelector('.product-card__overlay');
    if (overlay) {
      const badgeRect = badge.getBoundingClientRect();
      const scale = badgeRect.width / badge.offsetWidth || 1;
      const overlap = (badgeRect.bottom - overlay.getBoundingClientRect().top) / scale;
      // Değişken overlay'e yazılır: koleksiyon ızgarası kartın kendi style özniteliğini animasyon sonrası temizliyor
      overlay.style.setProperty('--hp-orange-band-overlap', `${Math.max(0, Math.ceil(overlap))}px`);
    }

    return compact;
  };

  const tick = () => {
    const now = Date.now();

    document.querySelectorAll(SELECTOR).forEach((el) => {
      const expires = new Date(el.dataset.expires).getTime();
      const valueEl = el.querySelector('[data-value]');
      if (!valueEl || Number.isNaN(expires)) return;

      const badge = el.closest(`.${BADGE}`);
      const card = el.closest('.product-card');
      if (!badge) return;

      const diff = expires - now;
      if (diff <= 0) {
        el.hidden = true;
        badge.classList.remove(`${BADGE}--timer`, `${BADGE}--no-icons`);
        card?.querySelector('.product-card__overlay')?.style.removeProperty('--hp-orange-band-overlap');
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const clock = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      const fullText = days > 0 ? `${days}g ${clock}` : clock;

      const width = badge.offsetWidth;
      if (width === 0) return; // görünmeyen kart (kapalı mega menü vb.): açılınca ölçülür

      // Genişlik ya da metin uzunluğu değişmedikçe yeniden ölçülmez
      const key = `${width}|${fullText.length}`;
      let layout = layouts.get(el);
      if (!layout || layout.key !== key) {
        layout = { key, compact: measure(el, badge, card, valueEl, fullText) };
        layouts.set(el, layout);
      }

      const compact = layout.compact && days > 0;
      el.classList.toggle(`${COUNTDOWN}--compact`, compact);
      render(valueEl, compact ? `${days}g ${pad(hours)}:${pad(minutes)}` : fullText);
      el.hidden = false;
    });
  };

  const remeasure = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => layouts.delete(el));
    tick();
  };

  const start = () => {
    tick();
    setInterval(tick, 1000);
    // Web fontu yüklenince genişlikler değişir: yeniden ölç
    document.fonts?.ready.then(remeasure);
    // Liste filtre / sıralama / sayfalama ile yeniden çizilince (morph) sunucudan gelen işaretleme sayacı yine
    // gizli getirir ve şerit payını (--hp-orange-band-overlap) siler; genişlik aynı kaldığı için ölçüm anahtarı
    // değişmez. Beklemeden yeniden ölçülür: sayaç bir sonraki saniyeye kadar kaybolmaz, şerit görselin üstüne binmez.
    document.addEventListener('section:content-updated', remeasure);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
